import { render, staticRenderFns } from "./relatorio-pdf.vue?vue&type=template&id=65ca1a7b"
import script from "./relatorio-pdf.vue?vue&type=script&lang=ts"
export * from "./relatorio-pdf.vue?vue&type=script&lang=ts"
import style0 from "./relatorio-pdf.vue?vue&type=style&index=0&id=65ca1a7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports